// We had to remove the register functionality from slate as it causes conflicts with sections anywhere.
const sections = document.querySelectorAll('[data-section-type="text-block"]');
if (sections.length > 0) {
    [...sections].forEach((section) => {
        // This is to remove padding top when two or more text-block with white background are added next to eachother.
        if (section.className.includes('white')) {
            section.parentElement.classList.add('white');
        }
    });
}
